<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t("WORKSHOPS_TITLE") }}
                <v-spacer></v-spacer>
                <v-text-field
                    append-icon="mdi-magnify"
                    :label="$t('WORKSHOPS_SEARCH')"
                    v-model="search"
                    class="ml-4"
                ></v-text-field>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense >
                        <v-list-item
                            v-if="authorizations.workshops.create"
                            link
                            @click="openCreateForm"
                            >
                            <v-list-item-avatar>
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>{{ $t('new_work_shop') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.workshops.update && selected.workShop.length == 1"
                            link
                            @click="openEditForm(selected.workShop[0].id)"
                            :disabled="!selected.workShop[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.workShop[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.workshops.delete && selected.workShop.length == 1"
                            link
                            @click="openDeleteDecisionDialog(selected.workShop[0].id)"
                            :disabled="!selected.workShop[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.workShop[0].deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-subtitle>{{ $t('WORKSHOPS_SUBTITLE') }}</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table
                    dense
                    :items="workshops"
                    :headers="headers.workshops"
                    v-model="selected.workShop"
                    show-select
                    single-select
                    :search="search">
                </v-data-table>
                <!-- <v-simple-table>
                    <thead>
                        <tr>
                            <th>الورشة</th>
                            <th>الكود</th>
                            <th>الخيارات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="workshop in workshops" :key="workshop.id">
                            <td>{{ workshop.name }}</td>
                            <td>{{ workshop.code }}</td>
                            <td>
                                <v-btn
                                    v-if="authorizations.workshops.update"
                                    icon
                                    :disabled="!workshop.meta.deletable"
                                    @click="openDeleteDecisionDialog(workshop.id)"
                                    >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn 
                                    v-if="authorizations.workshops.delete"
                                    icon
                                    :disabled="!workshop.meta.editable"
                                    @click="openEditForm(workshop.id)"
                                    >
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table> -->
            </v-card-text>
        </v-card>
        <WorkshopDialog 
            :display="workshopDialog.display"
            :editMode="workshopDialog.editMode"
            :recordId="workshopDialog.recordId"
            @closeMe="closeWorkshopDialog"
            @success="successAlert"
            @error="errorAlert"
            ref="WorkshopDialog"
            />
        <DecisionDialog 
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog 
            ref="alertDialog"
            />
    </div>
</template>

<script>
import WorkshopDialog from '../components/WorkshopDialog';
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import inArray from '../utils/inArray';

import { mapActions, mapState } from 'vuex'

export default {
    name: "Workshop", 
    components: {
        WorkshopDialog,
        DecisionDialog,
        AlertDialog
    },
    data() {
        return {
            search: null,
            workshopDialog: {
                display: false,
                recordId: null,
                editMode: false
            },
            selected: {
                workShop: []
            },
            decisionDialog: {
                switch: false,
                title: null,
                content: null,
                recordId: null
            },
            loading: {
                data: true
            },
            headers: {
                workshops: [
                    {text: this.$t('WORKSHOP_NAME'), value: "name"},
                    {text: this.$t('WORKSHOP_CODE'), value: "code"},
                ]
            }
        }
    },
    computed: {
        ...mapState("workshop", ["workshops"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    methods: {
        ...mapActions("workshop", ["fetchAll", "removeWorkshop", "showWorkshop"]),
        removeDialog(id) {
            this.decisionDialog.title = this.$t('DELETE_CONFIRM_TITLE');
            this.decisionDialog.content = this.$t('DELETE_CONFIRM_CONTENT');
            this.decisionDialog.switch = true;
            this.decisionDialog.recordId = id;
        },
        remove(id) {
            this.removeWorkshop(id)
                .then(response => {
                    this.decisionDialog.switch = false;
                    this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    this.fetchAll();
                })
                .catch(error => {
                    this.decisionDialog.switch = false;
                    this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                })
        },
        openCreateForm() {
            this.workshopDialog.display = true
            this.workshopDialog.recordId = null
            this.workshopDialog.editMode = false
        },
        openEditForm(id) {
            this.showWorkshop(id)
                .then(() => {
                    this.workshopDialog.display = true,
                    this.workshopDialog.recordId = id,
                    this.workshopDialog.editMode = true
                    this.$refs.WorkshopDialog.fillForm();
                })
                .catch((error) => {
                    this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                });
        },
        closeWorkshopDialog() {
            this.workshopDialog.display = false,
            this.workshopDialog.recordId = null,
            this.workshopDialog.editMode = false
        },
        successAlert(message) {
            this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), message);
        },
        errorAlert(message) {
            this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), message);
        },
        openDeleteDecisionDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE",
                id: id
            });
        },
        submitDecisionDialog(params) {
            if(params.action == 'DELETE') {
                this.removeWorkshop(params.id)
                    .then(response => {
                        this.fetchAll();
                        this.$refs.alertDialog(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.$refs.alertDialog(this.$t('ERROR_TITLE'), error.message);
                    })
            }
        },
        inArray,
        uneditableField(field) {
            return this.form.meta && inArray(field, this.form.meta.uneditable_fields) && this.editMode;
        }
    },
    async created() {
        this.loading.data = true;
        if(this.workshops.length == 0) await this.fetchAll();
        this.loading.data = false;
    },
    mounted() {
       
    }
}
</script>